export default __webpack_public_path__ + "static/bc_en_2-ac1ba87240d4669975be9d00c33f9249.mp4";